import Axios from "axios"
import { Formik } from "formik"
import { useEffect, useState } from "react"
import { Card, Modal } from "react-bootstrap"
import { useHistory, useLocation, useParams } from "react-router-dom"
import * as Yup from "yup"
import { PPAApi } from "../../../api"
import {
  ActionButton,
  BackButton,
  DataStatus,
  TextArea
} from "../../../components"
import { DateConvert, GuestMiddleware } from "../../../utilities"
import {
  InfoKegiatanSection,
  InfoPPASection,
  InfoProgramSection,
  InfoSubKegiatanSection
} from "./Section"
import { TabItemSumberDaya } from "./Tabs"

const DetailPPA = ({ setNavbarTitle }) => {
  const history = useHistory()
  const location = useLocation()

  const { id } = useParams()
  const { no_ppa, tab } = location.state
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [dataSubKegiatan, setDataSubKegiatan] = useState({})
  const [approveStatus, setApproveStatus] = useState("V")
  const [dataApproval, setDataApproval] = useState([])

  const [modalConfig, setModalConfig] = useState({
    show: false,
    type: "",
    title: ""
  })

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: ""
  })

  const getInitialData = () => {
    setIsPageLoading(true)

    // GET SINGLE DETAIL
    Axios.all([
      PPAApi.getSingle({
        no_ppa: no_ppa,
        id_ppa: id
      })
    ])
      .then(
        Axios.spread((data) => {
          const { approval, detail } = data.data.data
          const behavior = data.data.data.behavior
            ? data.data.data.behavior
            : "V"
          setDataSubKegiatan(detail)
          setDataApproval(approval ?? [])
          setApproveStatus(behavior.toUpperCase())
        })
      )
      .catch(() => {
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!"
        })
      })
      .finally(() => setIsPageLoading(false))
  }

  const checkAlert = () => {
    const locationState = location.state

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant
        })
      }
    }
  }

  const ModalSection = ({ values, isSubmitting, handleSubmit }) => {
    const ModalContent = () => (
      <>
        <Modal.Body className="text-center">
          <p>
            <h6>
              <b>
                {modalConfig.title === "approve"
                  ? approveStatus === "A"
                    ? "Approve"
                    : "Verify"
                  : modalConfig.title}{" "}
                dengan catatan :
              </b>
            </h6>
            <span>{values.catatan}</span>
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <ActionButton
            variant="outline-secondary"
            text="Batal"
            className="px-4"
            onClick={() =>
              setModalConfig({
                ...modalConfig,
                show: false
              })
            }
          />
          <ActionButton
            text={
              modalConfig.type === "APP"
                ? approveStatus === "A"
                  ? "Approve"
                  : "Verify"
                : modalConfig.type === "REJ"
                ? "Reject"
                : "Revise"
            }
            variant={
              modalConfig.type === "APP"
                ? "success"
                : modalConfig.type === "REV"
                ? "warning"
                : "danger"
            }
            className="m-1 px-3 text-white"
            onClick={handleSubmit}
            loading={isSubmitting}
          />
        </Modal.Footer>
      </>
    )

    console.log(approveStatus)

    return (
      <Modal
        show={modalConfig.show}
        onHide={() =>
          setModalConfig({
            ...modalConfig,
            show: false
          })
        }>
        <Modal.Header closeButton className="py-2 d-flex align-items-center">
          <Modal.Title>
            <small>{modalConfig.title}</small>
          </Modal.Title>
        </Modal.Header>
        <ModalContent />
      </Modal>
    )
  }

  const FormCard = ({
    values,
    handleChange,
    validateForm,
    errors,
    touched,
    setTouched,
    dirty
  }) => {
    const InfoItem = ({ title1, value1, title2, value2 }) => (
      <div className="col-md-4 mb-4">
        <small>{title1}</small>
        <br />
        <b>{value1}</b>
        <div className="mt-1" />
        <small>{title2}</small>
        <br />
        <b>{value2}</b>
      </div>
    )

    return (
      <Card className="mt-4 mb-5">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <b>Approval PPA</b>
        </Card.Header>
        <Card.Body>
          <div className="d-flex align-content-between flex-wrap">
            {dataApproval.map((val, index) => (
              <InfoItem
                key={index}
                title1={
                  val.status_approval == "VER"
                    ? `PEMERIKSA ${val.approval_level}`
                    : "PENGESAH"
                }
                value1={val.nama_karyawan ?? "-"}
                title2={"Catatan"}
                value2={val.catatan ?? "-"}
              />
            ))}
          </div>
          <hr />
          {tab !== "history" && (
            <div>
              <TextArea
                label="Catatan"
                name="catatan"
                placeholder="Masukan catatan"
                value={values.catatan}
                onChange={handleChange}
                error={errors.catatan && true}
                errorText={errors.catatan}
              />
              <div className="d-flex justify-content-end mt-3">
                {approveStatus === "A" ? (
                  <>
                    <ActionButton
                      text="Reject"
                      variant="danger"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "REJ",
                            title: (
                              <span className="text-danger">Reject PPA</span>
                            )
                          })
                        }
                        validateForm()
                      }}
                    />
                    <ActionButton
                      text={approveStatus === "A" ? "Approve" : "Verify"}
                      variant="success"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "APP",
                            title: (
                              <span className="text-success">Approve PPA</span>
                            )
                          })
                        }
                        validateForm()
                      }}
                    />
                  </>
                ) : (
                  <>
                    <ActionButton
                      text="Reject"
                      variant="danger"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "REJ",
                            title: (
                              <span className="text-danger">Reject PPA</span>
                            )
                          })
                        }
                        validateForm()
                      }}
                    />
                    <ActionButton
                      text="Revise"
                      variant="warning"
                      className="m-1 text-white"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "REV",
                            title: (
                              <span className="text-warning">Revise PPA</span>
                            )
                          })
                        }
                        validateForm()
                      }}
                    />
                    <ActionButton
                      text={approveStatus === "A" ? "Approve" : "Verify"}
                      variant="success"
                      className="m-1"
                      onClick={() => {
                        if (dirty) {
                          setModalConfig({
                            show: true,
                            type: "APP",
                            title: (
                              <span className="text-success">Approve PPA</span>
                            )
                          })
                        }
                        validateForm()
                      }}
                    />
                  </>
                )}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    )
  }

  useEffect(() => {
    setNavbarTitle("Approval PPA")
    getInitialData()
    checkAlert()

    return () => {
      setIsPageLoading(false)
    }
  }, [])

  return (
    <>
      <Formik
        initialValues={{ catatan: "" }}
        validationSchema={Yup.object().shape({
          catatan: Yup.string().required("Masukan Catatan")
        })}
        onSubmit={(values) => {
          const finalValues = {
            ...values,
            no_transaksi: dataSubKegiatan.no_ppa,
            status_approval: modalConfig.type,
            tgl_approval: DateConvert(new Date()).default,
            approval_baseline: dataSubKegiatan.baseline
          }

          PPAApi.approve(finalValues)
            .then((res) => {
              history.push("/human-resource/approval/ppa", {
                alert: {
                  show: true,
                  variant: "primary",
                  text: `${
                    modalConfig.type == "APP"
                      ? "Approve"
                      : modalConfig.type == "REV"
                      ? "Revise"
                      : "Reject"
                  } data berhasil!`
                }
              })
            })
            .catch((err) => {
              setAlertConfig({
                show: true,
                variant: "danger",
                text: `Simpan approval gagal! (${
                  err?.response?.data?.message ?? ""
                })`
              })
            })
            .finally(() => setModalConfig({ show: false }))
        }}>
        {({
          values,
          isSubmitting,
          handleChange,
          handleSubmit,
          errors,
          touched,
          validateForm,
          dirty
        }) =>
          isPageLoading ? (
            <DataStatus loading text="Memuat Data..." />
          ) : (
            <>
              <div className="d-flex justify-content-between mb-2">
                <span style={{ fontSize: "14px" }}>
                  <b>Detail Data Program</b>
                </span>
                <BackButton size="sm" onClick={() => history.goBack()} />
              </div>
              <Card className="mb-3">
                <Card.Body>
                  <InfoProgramSection data={dataSubKegiatan} />
                </Card.Body>
              </Card>

              <span style={{ fontSize: "14px" }}>
                <b>Detail Data Kegiatan</b>
              </span>
              <Card className="mb-3">
                <Card.Body>
                  <InfoKegiatanSection data={dataSubKegiatan} />
                </Card.Body>
              </Card>

              <span style={{ fontSize: "14px" }}>
                <b>Detail Data Sub Kegiatan</b>
              </span>
              <Card className="mb-3">
                <Card.Body>
                  <InfoSubKegiatanSection data={dataSubKegiatan} />
                </Card.Body>
              </Card>

              <span style={{ fontSize: "14px" }}>
                <b>Detail Data PPA</b>
              </span>
              <Card className="mb-3">
                <Card.Body>
                  <InfoPPASection data={dataSubKegiatan} />
                </Card.Body>
              </Card>

              <span style={{ fontSize: "14px" }}>
                <b>List Item Sumber Daya</b>
              </span>
              <Card className="mb-3">
                <TabItemSumberDaya data={dataSubKegiatan} type="read" />
              </Card>

              <GuestMiddleware>
                <FormCard
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  touched={touched}
                  validateForm={validateForm}
                  dirty={dirty}
                />
              </GuestMiddleware>

              <ModalSection
                values={values}
                isSubmitting={isSubmitting}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
              />
            </>
          )
        }
      </Formik>
    </>
  )
}

export default DetailPPA
